import React from "react";

const Game = () => {
  return (
    <div>{/* <iframe src="https://edrops.000webhostapp.com/game/" /> */}</div>
  );
};

export default Game;
